import React, { useState } from "react";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import Button from "@mui/material/Button";
import classes from "./JoinToNewsletter.module.css";

export default function JoinToNewsletter() {
  const [customerType, setCustomerType] = useState("");

  const SUBSCRIBE_TO_NEWSLETTER_FOR_WHOLESALE_CUSTOMERS_URL =
    "https://db0360de.sibforms.com/serve/MUIFADZ8ECwGCaw0ew12dAVPwqPcYZFBSQHiLTTfI9TzGQcY-NsPmBpGKiAns1mxETOQZw5crDwkZWcGTFzYenlTm35WMt_yWFqm9gtiSmPHJnXu-7KLaoHhzYJmb3UM0QVwi8TRQxL2ttXV-hkuLmbg6hakXF3kbpQmAID-Y6GmQfYusGoZz0ZAf3bMMbgd1PMdMrh2t0eVZPIO";

  const SUBSCRIBE_TO_NEWSLETTER_FOR_PRIVATE_CUSTOMERS_URL =
    "https://db0360de.sibforms.com/serve/MUIFAGjurSWF46z2g7cLvxGhEJ_KD4PhRkrLjM5ODE8SqusZZJGk7zZTjytnk0qW3QNvodT-85aCku7t0Bt_cQm7wteDde2fwPpgnAwmY0398AEPiYwlOrww8Nd0sajCpv5lUokUCp64dPNZuQNzGw26_Gq5XqkG_vDP7LXOIjJsEjfsdRKyUjgUqNLQXeACqH4rwK82siomDWC6";

  const handleChange = (event) => {
    setCustomerType(event.target.value);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (customerType === "wholesaleCustomer") {
      window.open(
        SUBSCRIBE_TO_NEWSLETTER_FOR_WHOLESALE_CUSTOMERS_URL,
        "_blank"
      );
    } else {
      // Private customer:
      window.open(SUBSCRIBE_TO_NEWSLETTER_FOR_PRIVATE_CUSTOMERS_URL, "_blank");
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className={classes.formContainer}>
        <div className={classes.headerText}>הירשמו עכשיו בחינם לניוזלטר</div>
        <div className={classes.center}>
          <div className={classes.radioButtonOption}>
            <input
              type="radio"
              id="wholesaleRadioButton"
              name="newsletterCustomerType"
              value="wholesaleCustomer"
              onChange={handleChange}
              required
            />
            <label htmlFor="wholesaleRadioButton" className={classes.radioText}>
              *אני בעל עסק
            </label>
          </div>
          <div className={classes.radioButtonOption}>
            <input
              type="radio"
              id="privateRadioButton"
              name="newsletterCustomerType"
              value="privateCustomer"
              onChange={handleChange}
              required
            />
            <label htmlFor="privateRadioButton" className={classes.radioText}>
              *אני לקוח פרטי
            </label>
          </div>
        </div>
        <button type="submit" className={classes.submitButton}>
          רישמו אותי
        </button>
      </div>
    </form>
  );
}
